import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const Agency = Loadable(lazy(() => import('./Agency')));

const agencyRoutes = [
  {
    path: '/Agency',
    element: <Agency />
  },
  {
    path: '/UploadHeaderFooterAgency',
    element: <Agency />
  }
]

export default agencyRoutes;
